import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

import { LeaderboardScore } from 'api';
import { useCurrentUser } from 'hooks';

interface IProps {
  userScore: LeaderboardScore;
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: `${theme.spacing(1)}px 0`,
  },
  number: {
    fontSize: theme.typography.pxToRem(28),
    lineHeight: theme.typography.pxToRem(32),
  },
}));

const UserScore: FC<IProps> = ({ userScore }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const currentUser = useCurrentUser();

  const { ranking, position_change, score } = userScore;
  const isCurrentUser = currentUser.id === userScore.user_id;

  function getChange() {
    if (position_change === 0) {
      return '--';
    }

    return position_change > 0 ? (
      <ArrowUpwardIcon color="primary" />
    ) : (
      <ArrowDownwardIcon color="disabled" />
    );
  }

  return (
    <Grid container justify="space-between" className={classes.root}>
      <Grid item>{getChange()}</Grid>
      <Grid item>
        <Typography>{isCurrentUser ? t('components:yourRank') : t('common:rank')}</Typography>
        <Typography className={classes.number}>{ranking}</Typography>
      </Grid>
      <Grid item>
        <Typography>{t('common:change')}</Typography>
        <Typography className={classes.number}>{position_change}</Typography>
      </Grid>
      <Grid item>
        <Typography>{t('common:point_plural')}</Typography>
        <Typography className={classes.number}>{score}</Typography>
      </Grid>
    </Grid>
  );
};

export default UserScore;
